import { useCompanyContext } from '../../../../../contexts';
import { ESellerStore as Platform } from '../../../../../Types';

interface UseGetFieldList {
  step: number;
}

export function useGetFieldList({ step }: UseGetFieldList) {
  const { business } = useCompanyContext();
  const isAmzSeller = business?.sellerStore === Platform.amazon;

  const displayFields = [
    { label: 'Product URL', key: 'url', step: 1 },
    { label: 'Product Name', key: 'name', step: 2 },
    { label: 'Batches purchased', key: 'numShipmentsLastYear', step: 3 },
    { label: 'Units to be purchased', key: 'nextBatch', step: 4 },
  ];

  return displayFields
    .filter(({ key }) => !isAmzSeller || (isAmzSeller && key !== 'url'))
    .filter((field) => field.step < step);
}
